import React, { Suspense, lazy } from 'react';
import { createHashRouter, RouterProvider } from 'react-router-dom';

import Loading from '@/components/loading';

// 通过 React.lazy 实现路由级按需加载，分包减小单个 bundle 体积
const SinoMotiveLayout = lazy(() => import('../../layouts/default-layout/SinoMotiveLayout'));
const CommodityList = lazy(() => import('../../pages/commodity-list'));
const ShoppingCart = lazy(() => import('../../pages/shopping-cart'));
const OrderConfirmation = lazy(() => import('../../pages/order-confirmation'));
const OrderList = lazy(() => import('@/pages/order-list'));
const OrderDetails = lazy(() => import('@/pages/order-details'));
const AddressList = lazy(() => import('../../pages/address-list'));
const ShipmentDetails = lazy(() => import('@/pages/shipment-details'));
const Page404 = lazy(() => import('@/pages/page404'));
const Login = lazy(() => import('@/pages/login'));
const Maintenance = lazy(() => import('@/pages/Maintenance'));

const AppRouterProvider = () => {
  const router = createHashRouter([
    {
      path: '/',
      element: <SinoMotiveLayout />,
      errorElement: <Page404 />,
      children: [
        {
          path: '/login',
          element: <Login />,
        },
        {
          index: true,
          element: <CommodityList />,
        },
        {
          path: '/search',
          element: <CommodityList />,
        },
        {
          path: '/shopping/cart',
          element: <ShoppingCart />,
        },
        {
          path: '/order/confirmation',
          element: <OrderConfirmation />,
        },
        {
          path: '/order/list',
          element: <OrderList />,
        },
        {
          path: '/order/:orderId',
          element: <OrderDetails />,
        },
        {
          path: '/shipment/:shipmentId',
          element: <ShipmentDetails />,
        },
        {
          path: '/address/list',
          element: <AddressList />,
        },
      ],
    },
    {
      path: '/maintenance',
      element: <Maintenance />,
      errorElement: <Page404 />,
    },
  ]);
  // 用 Suspense 统一包裹，提供加载占位符，支持所有懒加载子路由
  return (
    <Suspense fallback={<Loading />}>
      <RouterProvider router={router} fallbackElement={<Page404 />} />
    </Suspense>
  );
};

export default AppRouterProvider;
